import { useOptimizelyFeatureFlag } from '@shared/v2/contexts/optimizely';

export const useIncreaseRange = () => {
  const [decision] = useOptimizelyFeatureFlag('eja-increase-range');
  return decision?.enabled || false;
};
